import { ByteArray } from "../ByteArray"
import { ICommand } from "./ICommand"

export class CMDPsLastSeenRank implements ICommand
{

	public Rank : number = 0;

	public constructor()
	{
	}

	public fromBytes(ba : ByteArray) : void
	{
		this.Rank = ba.readUint16();
	}

	public toBytes() : ByteArray
	{
		let ba: ByteArray = new ByteArray();

		ba.writeUint16(this.Rank);

		return ba;
	}

	public clone() : ICommand
	{
		let cmd : ICommand = new CMDPsLastSeenRank();
		cmd.fromBytes(this.toBytes());

		return cmd;
	}

	public toString() : string
	{
		let str:string = '';
		str += 'Rank(W)='+this.Rank+' ';
		return str;
	}

	public getCmdID() : number
	{
		return 55104;
	}

	public getCmdName() : string
	{
		return 'PsLastSeenRank';
	}

}
